angular.module('bbl.services.logger-service', [])

.factory('logger', [function() {
  var logs = {
    log: angular.noop,
    info: angular.noop,
    warn: angular.noop,
    error: angular.noop,
  };

  if(localStorage.getItem('debug')) {
    logs = {
      log: console.log.bind(console),
      info: console.info.bind(console),
      warn: console.warn.bind(console),
      error: console.error.bind(console),
    };
  }

  return angular.extend(logs, {
    for: function(pref) {
      return Object.keys(logs).reduce(function(r, c) {
        r[c] = logs[c].bind(0, pref);
        return r;
      }, {});
    }
  });
}]);
  


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/logger-service.js
 ** module id = 194
 ** module chunks = 0
 **/